import React, { PropsWithChildren } from 'react';
import theme from './SettingsSection.module.scss';

interface SettingsSectionListProps extends PropsWithChildren {}

const SettingsSectionList: React.FC<SettingsSectionListProps> = ({ children }) => {
    return <ul className={theme.list}>{children}</ul>;
};

export default SettingsSectionList;
